module.exports = "<uib-accordion close-others=\"$ctrl.closeOthers\">\r\n    <div uib-accordion-group class=\"panel-default\" heading=\"{{section.title}}\" ng-repeat=\"section in $ctrl.sections\">\r\n        <div ng-bind-html=\"section.content\"></div>\r\n    </div>\r\n</uib-accordion>"


//////////////////
// WEBPACK FOOTER
// ./client/components/accordion-widget/accordion-widget.component.html
// module id = 636
// module chunks = 0